import React from 'react';

import Link from 'next/link';

import { getBlogPostsUrl } from '../../helpers/urls';
import { ArrowLeftIcon } from '../Icons/ArrowLeftIcon';
import { ArrowRightIcon } from '../Icons/ArrowRightIcon';

interface IProps {
  active: number;
  startPage: number;
  endPage: number;
  paginationPath?: string;
}

const PaginatorItem = ({
  isActive = false,
  dataTestid,
  children,
}: {
  isActive?: boolean;
  dataTestid?: string;
  children: React.ReactNode;
}) => (
  <li
    className={`mx-0.5 inline-block cursor-pointer rounded-md px-4 py-1 align-top text-lg font-semibold ${
      isActive ? 'pointer-events-none bg-primary text-white no-underline' : ''
    }`}
    {...(dataTestid ? { 'data-testid': dataTestid } : {})}
  >
    {children}
  </li>
);

const Page = ({
  page,
  active,
  paginationPath,
}: {
  page: number;
  active: boolean;
  paginationPath?: string;
}) => (
  <PaginatorItem isActive={active}>
    <Link href={getBlogPostsUrl(page, paginationPath)} passHref>
      {page}
    </Link>
  </PaginatorItem>
);

export const Paginator = ({ startPage, endPage, active, paginationPath }: IProps) => {
  return (
    <div className="flex w-full flex-wrap items-center justify-center">
      <ul className="m-0">
        {startPage !== active && (
          <PaginatorItem dataTestid="PreviousArrow">
            <Link href={getBlogPostsUrl(active - 1, paginationPath)} passHref>
              <ArrowLeftIcon />
              <span className="sr-only">Previous Page</span>
            </Link>
          </PaginatorItem>
        )}
        {[...Array(endPage).keys()].map(index => (
          <Page
            key={`paginator-page-${index + 1}`}
            page={index + 1}
            active={active === index + 1}
            paginationPath={paginationPath}
          />
        ))}
        {endPage !== active && (
          <PaginatorItem dataTestid="NextArrow">
            <Link href={getBlogPostsUrl(active + 1, paginationPath)} passHref>
              <ArrowRightIcon />
              <span className="sr-only">Next Page</span>
            </Link>
          </PaginatorItem>
        )}
      </ul>
    </div>
  );
};
